/* eslint-disable import/no-extraneous-dependencies */
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VeeValidate from 'vee-validate';
import { sync } from 'vuex-router-sync';

import vuetifyAurora from 'vuetify-aurora';

// import 'vuetify-aurora/dist/aurora.min.css';

import App from './App';
import router from './router';
import store from './store';
import './plugins';
import vuetify from './plugins/vuetify';

// import locale
import appLang from './resources/lang/index';

sync(store, router);

Vue.config.productionTip = false;

// Vue.use(aurora);
Vue.use(vuetifyAurora);

Vue.use(VueI18n);

// setup validation
Vue.use(VeeValidate);

const rules = {
  required: value => !!value || 'Required.',
  passwordMin: v => v.length >= 8 || 'Min 8 characters',
};
Vue.prototype.$validation = {
  rules,
};

// setup locale
const messages = appLang;
const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages,
});

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App),
}).$mount('#app');
